import {
	DEFAULT_LOCALE,
	isI18nLocaleRoute,
	parseLocaleFromPath,
	switchLocaleInFullPath,
} from "~/utils/i18n-locale-routes";

/**
 * 无语言前缀的多语言路由 → 按上次语言偏好重定向到 /tw/... 或 /en/...
 * 带 /en/ 或 /tw/ 的链接打开后由 i18n 插件按 path 解析语言并持久化
 */
export default defineNuxtRouteMiddleware(to => {
	if (!isI18nLocaleRoute(to.path)) return;

	if (parseLocaleFromPath(to.path)) return;

	const localeCookie = useCookie("app-language", {
		default: () => DEFAULT_LOCALE,
		maxAge: 60 * 60 * 24 * 365,
		sameSite: "lax",
	});
	const preferred =
		localeCookie.value === "en" || localeCookie.value === "zh-TW"
			? localeCookie.value
			: DEFAULT_LOCALE;

	const target = switchLocaleInFullPath(to.fullPath, preferred);
	if (target !== to.fullPath) {
		return navigateTo(target, { redirectCode: 302 });
	}
});
